import React, { useState } from 'react';
import styles from '../../Home.module.css';

const faqData = [
  {
    q: 'Is Fyntiq something I need to install?',
    a: "No — Fyntiq is web-based, so all you need is a browser and an internet connection. There's also a mobile app for iOS and Android to manage invoices and payments on the go.",
  },
  {
    q: 'How fast do I get paid?',
    a: 'Most payments settle to your account in about two business days. Timing can vary by payment method and your account status.',
  },
  {
    q: 'How does chargeback protection work?',
    a: "Fyntiq screens transactions for fraud and covers eligible fraudulent disputes, handling the response on your behalf. Coverage applies to qualifying fraud-related chargebacks under your merchant agreement — it doesn't replace ordinary refunds or cover routine service disputes.",
  },
  {
    q: 'What does it cost?',
    a: "It's free to get started — you only pay standard per-transaction processing. See our Pricing page for full details.",
  },
  {
    q: 'Can my customers pay without a Fyntiq account?',
    a: 'Yes. Customers can pay any invoice or link by card, Apple Pay, or bank transfer without signing up. A Fyntiq Wallet just adds faster checkout and cash back.',
  },
];

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className={styles.sec} style={{ paddingTop: 0 }}>
      <div className={`${styles.container} ${styles.faqGrid}`}>
        <div className={`${styles.secHead} ${styles.sr}`} data-sr style={{ margin: 0 }}>
          <span className={styles.eyebrow}><span className={styles.dot} />FAQ</span>
          <h2 style={{ fontSize: 38 }}>Questions, answered.</h2>
        </div>
        <div className={styles.sr} data-sr>
          {faqData.map((item, i) => (
            <div key={item.q} className={`${styles.faqItem} ${openIndex === i ? styles.faqItemOpen : ''}`}>
              <div className={styles.faqQ} onClick={() => setOpenIndex(openIndex === i ? -1 : i)} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && setOpenIndex(openIndex === i ? -1 : i)}>
                {item.q} <span className={styles.pm}>+</span>
              </div>
              <div className={styles.faqA}><p>{item.a}</p></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faq;
